import script from "./UserAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAdmin.vue?vue&type=script&setup=true&lang=js"

import "./UserAdmin.vue?vue&type=style&index=0&id=66dd8714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66dd8714"]])

export default __exports__